import React from 'react';
import { Icon } from '@ansvar-sakerhet/ui/src/icons/Icon';
import { S } from './ActionsCell.styles';

export type ProjectRowTarget = {
  projectId: string;
  name: string;
};

type Props = {
  projectId: string;
  name: string;
  canDelete: boolean;
  onEdit: (target: ProjectRowTarget) => void;
  onDelete: (target: ProjectRowTarget) => void;
};

export const ActionsCell: React.FC<Props> = ({
  projectId,
  name,
  canDelete,
  onEdit,
  onDelete,
}) => {
  return (
    <S.ActionsContainer>
      <S.IconButton
        title="Byt namn på projekt"
        onClick={(e) => {
          e.stopPropagation();
          onEdit({ projectId, name });
        }}
      >
        <Icon src="Edit" width={18} height={18} />
      </S.IconButton>
      <S.IconButton
        $disabled={!canDelete}
        disabled={!canDelete}
        title={
          canDelete
            ? 'Ta bort projekt'
            : 'Projektet har redan kontroller eller underentreprenörer och kan inte tas bort'
        }
        onClick={(e) => {
          e.stopPropagation();
          if (!canDelete) return;
          onDelete({ projectId, name });
        }}
      >
        <Icon src="Trash" width={18} height={18} />
      </S.IconButton>
    </S.ActionsContainer>
  );
};
